import React from 'react';
import { Card, Tabs } from 'antd';
import PlanBilling from './PlanBilling';
import GlobalBillingConfiguration from './GlobalBillingConfiguration';

/**
 * Vista operativa de facturación de TheBlueCoding. La lógica de configuración,
 * factura directa y facturas generadas se mantiene en sus componentes actuales.
 */
const BillingManagement: React.FC = () => (
    <div className="tbc-admin-page">
        <Card bordered={false}>
            <Tabs
                destroyOnHidden
                items={[
                    {
                        key: 'operacion',
                        label: 'Operación de facturación',
                        children: <PlanBilling moduleView="billing" />
                    },
                    {
                        key: 'global',
                        label: 'Configuración global de facturación',
                        children: <GlobalBillingConfiguration />
                    }
                ]}
            />
        </Card>
    </div>
);

export default BillingManagement;
